import React, { PropsWithChildren } from 'react';
import { useError } from '~/shared/utils/errorBoundary/hooks/useError';
import { useTranslation } from '~/shared/utils/translation';
import { StyledErrorContent } from './styled';
import { Container } from '../container/container.component';

export const ErrorFallbackContent = ({ children }: PropsWithChildren) => {
    const { translate } = useTranslation();
    const { error } = useError();

    return (
        <Container>
            <StyledErrorContent>
                <div>{children ? children : translate('message.contentUnavailable')}</div>
                <div>Error: {error?.message}</div>
            </StyledErrorContent>
        </Container>
    );
};
